/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ChangeEvent, ReactElement } from "react";
import { I18n } from "i18n-js";
import * as locales from "../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import axios from "axios";
import styled from "styled-components";
import ScaleLoader from "react-spinners/ScaleLoader";

import _, { pluck } from "underscore";
import Alert from "./reusable/alert";
import FilterDropdown from "./reusable/filterDropdown";
import PendingAwardsFilterableTable from "./awards/pendingAwardsFilterableTable";
import Flyout from "./reusable/flyout";

import {
  ApprovalRequest,
  jQueryTooltipContainer,
} from "../interfaces/interfaces";
import setUpAxios from "../helperFunctions/helperFunctions";
import { handleFormatApprovalRequest } from "./awards/lib/utils";

const location = (window as any).location as Location;
declare const brandColor: string;

interface PendingUserClaimsState {
  alert: {
    show: boolean;
    message: string;
    type: string;
  };
  claims: ApprovalRequest[];
  isLoading: boolean;
  isFlyoutLoading: boolean;
  isNonFlyout: boolean;
  selectAllChecked: boolean;
  selectedFilter: string;
  claimChanged: boolean;
  filterOptions: string[][];
  currentUserID?: string;
}

const StyledControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export default class PendingUserClaims extends React.Component<PendingUserClaimsState> {
  state = {
    alert: {
      show: false,
      message: "",
      type: "",
    },
    claims: [],
    isLoading: false,
    isFlyoutLoading: false,
    isNonFlyout: false,
    selectAllChecked: false,
    selectedFilter: "All",
    claimChanged: false,
    filterOptions: [],
    currentUserID: "",
  };

  async componentDidMount(): Promise<void> {
    setUpAxios();

    let filterOptions;

    const currentPath = window.location.pathname;
    const pathsToNotFlyout = [
      "/awards/approval_requests",
      "/admin/awards/pending",
    ];

    this.setState({
      isFlyoutLoading: true,
      isNonFlyout: pathsToNotFlyout.some((path) => currentPath.includes(path)),
    });

    if ($(".claims-flyout-opener").length) {
      $(".claims-flyout-opener").prop("disabled", true);
    }

    try {
      const {
        data: {
          claims: pending_awards,
          filterOptions: awardFilterOptions,
          currentUserID: current_user_id,
        },
      } = await axios.get("/awards/approval_requests");

      const awards = pending_awards.map((award) => {
        return {
          claim: award,
          isLoading: false,
          selected: false,
        };
      });

      filterOptions = _.uniq(awardFilterOptions, false, (option) => {
        return option[1];
      });

      awards.sort((a, b) => {
        return (
          new Date(b.claim.createdAt).valueOf() -
          new Date(a.claim.createdAt).valueOf()
        );
      });

      this.setState({
        claims: awards,
        filterOptions,
        isLoading: false,
        isFlyoutLoading: false,
        currentUserID: current_user_id || "",
      });
    } catch (error) {
      const message = error.response.data || error.response.data.message;
      this.handleShowAlert(error.status, message);
      this.setState({
        isLoading: false,
        isFlyoutLoading: false,
      });
    }

    if ($(".claims-flyout-opener").length) {
      $(".claims-flyout-opener")
        .prop("disabled", false)
        .on("click", (e) => {
          e.preventDefault();
          $(".flyout").toggleClass("open");
          $(".main-wrapper").css("display", "none");
          const awardId = $(e.target).data("filter");
          if (awardId) {
            this.setState({ selectedFilter: awardId });
          } else {
            this.setState({ selectedFilter: "All" });
          }
        });
    }

    const tooltipContainer = $(
      '[data-toggle="tooltip"]'
    ) as jQueryTooltipContainer;
    tooltipContainer.tooltip();
  }

  render(): ReactElement {
    if (this.state.isNonFlyout) {
      if (this.state.isFlyoutLoading) {
        return (
          <div className="award-loading">
            <ScaleLoader
              color={brandColor}
              loading={this.state.isFlyoutLoading}
              height={45}
              width={6}
              margin={6}
            />
          </div>
        );
      }

      return (
        <React.Fragment>
          <StyledControls className="controls">
            {this.renderControls()}
          </StyledControls>
          {this.renderTable()}
        </React.Fragment>
      );
    }

    return (
      <Flyout
        id="claims-flyout"
        title={i18n.translate("awards.claimable_awards.pending_awards")}
        handleCloseFlyout={this.handleCloseFlyout}
      >
        <div className="controls">{this.renderControls()}</div>
        {this.renderTable()}
      </Flyout>
    );
  }

  renderControls = (): ReactElement => {
    return (
      <React.Fragment>
        {this.renderAlert()}
        {this.renderFilter()}
        {this.renderMultiselectControls()}
      </React.Fragment>
    );
  };

  renderAlert = (): ReactElement => {
    if (this.state.alert.show) {
      return (
        <Alert
          handleCloseAlert={this.handleCloseAlert}
          message={this.state.alert.message}
          type={this.state.alert.type}
        />
      );
    }

    return null;
  };

  renderFilter = (): ReactElement => {
    return (
      <FilterDropdown
        filterOptions={this.state.filterOptions}
        handleChangeFilter={this.handleChangeFilter}
        selectedFilter={this.state.selectedFilter}
      />
    );
  };

  renderMultiselectControls = (): ReactElement => {
    if (this.getAnySelected()) {
      return (
        <div className="multiselect-controls">
          <button
            className="btn btn-approve multiple-submit"
            disabled={this.state.isLoading}
            onClick={this.handleApproveMany}
            type="button"
          >
            <i className="fa fa-check" />
            <span>&nbsp;Approve Selected</span>
          </button>
          <button
            className="btn btn-deny multiple-submit"
            disabled={this.state.isLoading}
            onClick={this.handleDenyMany}
            type="button"
          >
            <i className="fa fa-times" />
            <span>&nbsp;Deny Selected</span>
          </button>
          {this.renderSpinner()}
        </div>
      );
    }

    return null;
  };

  renderSpinner = (): ReactElement => {
    if (this.state.isLoading) {
      return <i className="fa fa-sync fa-spin spinner" />;
    }

    return null;
  };

  renderTable = (): ReactElement => {
    return (
      <PendingAwardsFilterableTable
        claims={this.state.claims}
        handleApprovalRequest={this.handleApprovalRequest}
        handleToggleClaim={this.handleToggleClaim}
        handleToggleSelectAll={this.handleToggleSelectAll}
        selectAllChecked={this.state.selectAllChecked}
        selectedFilter={this.state.selectedFilter}
      />
    );
  };

  handleToggleSelectAll = (): void => {
    if (!this.state.selectAllChecked) {
      const updatedClaims = _.map(
        this.state.claims,
        (claim: ApprovalRequest) => {
          if (
            this.state.selectedFilter === "All" ||
            this.state.selectedFilter === claim.claim.awardId
          ) {
            return {
              ...claim,
              selected: claim.claim.active,
            };
          }
          return {
            ...claim,
            selected: false,
          };
        }
      );

      this.setState({
        selectAllChecked: true,
        claims: [...updatedClaims],
      });
    } else {
      const updatedClaims = _.map(
        this.state.claims,
        (claim: ApprovalRequest) => {
          return {
            ...claim,
            selected: false,
          };
        }
      );

      this.setState({
        selectAllChecked: false,
        claims: [...updatedClaims],
      });
    }
  };

  handleCloseAlert = (): void => {
    this.setState({
      alert: {
        show: false,
        message: "",
        type: "",
      },
    });
  };

  handleChangeFilter = (e: ChangeEvent<HTMLSelectElement>): void => {
    this.setState({
      selectedFilter: e.target.value,
      selectAllChecked: false,
    });
  };

  handleApprovalRequest = (claim: ApprovalRequest, url: string): void => {
    this.handleClaimIsLoading(claim, true);
    const formattedApprovalRequests = handleFormatApprovalRequest(
      claim.claim,
      this.state.currentUserID
    );

    axios
      .post(url, { approval_requests: formattedApprovalRequests })
      .then((response) => {
        this.handleShowAlert(response.status, response.data.message);
        this.handleRemoveClaims([claim.claim.id]);
        this.handleClaimIsLoading(claim, false);
      })
      .catch((error) => {
        const errorIDs = pluck(error.response.data, "approval_request_id");
        const idsToRemove = formattedApprovalRequests.reduce((acc, object) => {
          if (!errorIDs.includes(object.id)) {
            acc.push(object.id);
          }
          return acc;
        }, []);

        this.handleErroredClaims(error.response.data);

        this.handleShowAlert(error.status, "Something went wrong with the selected requests.");
        this.setState({
          isLoading: false,
        });

        if (idsToRemove.length) this.handleRemoveClaims(idsToRemove);
      });
  };

  handleClaimIsLoading = (claim: ApprovalRequest, status: boolean): void => {
    const updatedClaims = this.getUpdatedClaims(claim);

    this.setState({
      claims: updatedClaims,
      claimChanged: true,
    });
  };

  handleGetSelectedApprovalRequests = (): {
    id: string;
    level_positon: string;
  }[] => {
    return this.state.claims
      .reduce((acc, claim) => {
        const hasApprovalProcess = Array.isArray(claim.claim.approvers[0]);
        if (claim.selected && hasApprovalProcess) {
          const formattedApprovalRequests = handleFormatApprovalRequest(
            claim.claim,
            this.state.currentUserID
          );
          acc.push(formattedApprovalRequests);
        }
        return acc;
      }, [])
      .flat();
  };

  handleRemoveClaims = (ids: string[]): void => {
    const currentClaims = [...this.state.claims];
    const remainingClaims = currentClaims.filter((claim: ApprovalRequest) => {
      return !ids.includes(claim.claim.id);
    });

    this.setState({
      claims: [...remainingClaims],
    });
  };

  handleErroredClaims = (errorData: any): void => {
    const currentClaims = [...this.state.claims];

    errorData.forEach((error: any) => {
      const i = currentClaims.findIndex((claim: ApprovalRequest) => {
        return claim.claim.id === error.approval_request_id;
      });

      if (i > -1) {
        currentClaims[i].errorMessage = error.message;
      }
    });

    this.setState({ claims: currentClaims });
  };

  handleApproveMany = async (): Promise<void> => {
    const selectedIDObjects = this.handleGetSelectedApprovalRequests();
    const selectedApprovalRequestIDs = pluck(selectedIDObjects, "id");

    let status;
    let message;

    try {
      this.setState({
        isLoading: true,
        claimChanged: true,
      });

      const approvalRequestResponse =
        selectedApprovalRequestIDs.length &&
        (await axios.post(
          "/awards/approval_request_decisions/approve_multiple",
          {
            approval_requests: selectedIDObjects,
          }
        ));

      ({ status } = approvalRequestResponse);
      ({
        data: { message },
      } = approvalRequestResponse);

      this.setState({
        isLoading: false,
        selectAllChecked: false,
      });

      this.handleRemoveClaims([...selectedApprovalRequestIDs]);
    } catch (error) {
      let idsToRemove = [];
      if (Array.isArray(error?.response?.data)) {
        const errorIDs = pluck(error.response.data, "approval_request_id");
        idsToRemove = selectedIDObjects.reduce((acc, object) => {
          if (!errorIDs.includes(object.id)) {
            acc.push(object.id);
          }
          return acc;
        }, []);
      }

      ({ status } = error);
      message = "Something went wrong with the selected requests.";

      this.setState({
        isLoading: false,
      });

      this.handleErroredClaims(error.response.data);
      this.handleRemoveClaims(idsToRemove);
    }

    this.handleShowAlert(status, message);
  };

  handleDenyMany = async (): Promise<void> => {
    const selectedIDObjects = this.handleGetSelectedApprovalRequests();
    const selectedApprovalRequestIDs = pluck(selectedIDObjects, "id");
    let status;
    let message;

    try {
      this.setState({
        isLoading: true,
        claimChanged: true,
      });

      const approvalRequestResponse =
        selectedApprovalRequestIDs.length &&
        (await axios.post("/awards/approval_request_decisions/deny_multiple", {
          approval_requests: selectedIDObjects,
        }));

      ({ status } = approvalRequestResponse);
      ({
        data: { message },
      } = approvalRequestResponse);

      this.setState({
        isLoading: false,
        selectAllChecked: false,
      });

      this.handleRemoveClaims([...selectedApprovalRequestIDs]);
    } catch (error) {
      let idsToRemove = [];
      if (Array.isArray(error.response.data)) {
        const errorIDs = pluck(error.response.data, "approval_request_id");
        idsToRemove = selectedIDObjects.reduce((acc, object) => {
          if (!errorIDs.includes(object.id)) {
            acc.push(object.id);
          }
          return acc;
        }, []);
      }

      ({ status } = error);
      message = "Something went wrong with the selected requests.";

      this.setState({
        isLoading: false,
      });

      this.handleErroredClaims(error.response.data);
      this.handleRemoveClaims(idsToRemove);
    }

    this.handleShowAlert(status, message);
  };

  handleToggleClaim = (claim: ApprovalRequest): void => {
    const updatedClaims = this.getUpdatedClaims(claim);
    const selectAllChecked = this.getSelectAllChecked(updatedClaims);
    this.setState({
      claims: updatedClaims,
      selectAllChecked,
    });
  };

  handleShowAlert = (status: number, message: string): void => {
    const type = status >= 200 && status < 400 ? "success" : "failure";
    this.setState({
      alert: {
        show: true,
        message,
        type,
      },
    });
  };

  getUpdatedClaims = (claim: ApprovalRequest): ApprovalRequest[] => {
    const i = this.state.claims.findIndex((stateClaim: ApprovalRequest) => {
      return claim.claim.id === stateClaim.claim.id && stateClaim.claim.active;
    });
    const updatedClaims = [...this.state.claims];

    if (i > -1) {
      updatedClaims[i].selected = !updatedClaims[i].selected;
    }

    return updatedClaims;
  };

  getSelectAllChecked = (claims: ApprovalRequest[]): boolean => {
    return _.every(claims, (claim: ApprovalRequest) => {
      return claim.selected;
    });
  };

  getAnySelected = (): boolean => {
    const selected = this.state.claims.filter((claim) => {
      return claim.selected;
    });

    return selected.length > 1;
  };

  handleCloseFlyout = (): void => {
    if (this.state.claimChanged) {
      location.hash = `claimable`;
      location.reload();
    } else {
      $(".flyout").toggleClass("open");
      $(".main-wrapper").css("display", "block");
    }
  };
}
